<template>
  <div class="contact">
    <h1 style="font-family: 'Virgula Vulgaris'">Contáctame</h1>
    <v-row>
      <v-col cols="12" sm="12" md="5">
        <v-row>
          <v-col cols="1">
            <dl>
              <dt>
                <v-icon color="primary">mdi-phone</v-icon>
              </dt>
            </dl>
          </v-col>
          <v-col cols="11">
            <dl>
              <dt>Teléfonos</dt>
            </dl>
            <dd>
              Perú: 01 6643745 | +51 987 578 867
              <br/>
              EEUU: +1 305 454 4180
              <br/>
              <a
                  href="https://api.whatsapp.com/send?phone=51987578867&text=Hola,%20quiero%20contactarme%20con%20ustedes"
                  color="#006400"
                  target="_blank">WhatsApp</a>
            </dd>
          </v-col>
        </v-row>
        <!--<v-row>
          <v-col cols="1">

          </v-col>
          <v-col cols="11">
            <dd>
              Perú: 01 6643745 | +51 967 576 867
              <br/>
              EEUU: +1 305 454 4180
              <br/>
              <a
                  href="https://api.whatsapp.com/send?phone=51967576867&text=Hola,%20quiero%20contactarme%20con%20ustedes"
                  color="#006400"
                  target="_blank">WhatsApp</a>
            </dd>
          </v-col>
        </v-row>-->
        <v-row>
          <v-col cols="1">
            <dl>
              <dt>
                <v-icon color="primary">mdi-home</v-icon>
              </dt>
            </dl>
          </v-col>
          <v-col cols="11">
            <dl>
              <dt>Sedes</dt>
            </dl>
            <dd>
              Lima, Perú
              <br/>
              Florida, EEUU
            </dd>
          </v-col>
        </v-row>
        <!--<v-row>
          <v-col cols="1">

          </v-col>
          <v-col cols="11">
            <dd>
              Lima, Perú
              <br/>
              Florida, EEUU
            </dd>
          </v-col>
        </v-row>-->
        <v-row>
          <v-col cols="1">
            <dl>
              <dt>
                <v-icon color="primary">mdi-clock</v-icon>
              </dt>
            </dl>
          </v-col>
          <v-col cols="11">
            <dl>
              <dt>Hora de atención</dt>
            </dl>
            <dd>
              Lunes a viernes: 9:00 am a 6:00 pm <br/>
              Sábado: 9:00 am a 1:00 pm
            </dd>
          </v-col>
        </v-row>
       <!-- <v-row>
          <v-col cols="1">

          </v-col>
          <v-col cols="11">
            <dd>
              Lunes a viernes: 9:00 am a 6:00 pm <br/>
              Sábado: 9:00 am a 1:00 pm
            </dd>
          </v-col>
        </v-row>-->
        <!--<dl>
          <dt><v-icon>mdi-pencil</v-icon>Teléfonos</dt>
          <dd>
            Perú: 01 6643745 | +51 967 576 867
            <br/>
            EEUU: +1 305 454 4180
            <br/>
            <a
                href="https://api.whatsapp.com/send?phone=51967576867&text=Hola,%20quiero%20contactarme%20con%20ustedes"
                color="#006400"
                target="_blank">WhatsApp</a>
          </dd>
          <dt>Sedes</dt>
          <dd>
            Lima, Perú
            <br/>
            Florida, EEUU
          </dd>
          <dt>Hora de atención</dt>
          <dd>
            Lunes a viernes: 9:00 am a 6:00 pm <br/>
            Sábado: 9:00 am a 1:00 pm
          </dd>
        </dl>-->
      </v-col>
      <v-col sm="12" md="7">
        <img src="../assets/ruben.png" alt="" width="100%">
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'Contact',
}
</script>
<style lang="scss" scoped>
* {
  font-family: "Avenir", sans-serif;
  color: #656565;
}

.contact {
  width: 100%;
}

h1 {
  margin-bottom: 6px;
}

a {
  font-size: 17px;
  font-weight: 400;
  text-decoration: none;
  margin: 10px 0 10px 0;
  display: inline-block;
}

dl {
  margin-top: 12px;
  color: #656565;
  font-size: 14px;
  font-weight: 200;
  line-height: 1.8em;

  dt {
    font-weight: 800;
    font-size: 18px;
    margin-top: 12px;
    margin-bottom: 6px;
  }

  dd {
    font-size: 16px;
    line-height: 27px;
  }
}
</style>
